export enum ShopifyAdditionalChoose {
  NoDefault,
  Show,
  NotShow,
}
